import { type App } from 'vue'
import { cbcopy } from '../utils/misc'
import { useToast } from './elements/toast'

export default {
  install(app: App) {
    const map = new WeakMap()
    const toast = useToast()

    function copy(el: HTMLElement) {
      const data = map.get(el)
      if (!data) return
      cbcopy(data.text)
      toast.show({
        text: 'Copied to clipboard.',
      })
    }

    app.directive('clipboard', {
      beforeMount(el, binding) {
        const data = map.get(el) ?? {}
        data.text = binding.value
        data.fn = copy.bind(null, el)
        el.addEventListener('click', data.fn)
        map.set(el, data)
      },
      unmounted(el) {
        const data = map.get(el)
        if (!data) return
        el.removeEventListener('click', data.fn)
        map.delete(el)
      },
    })
  },
}
